<template>
  <div class="jin-play-box tv-video">
    <div class="jin-play-box__h vip-video--header">
      <div class="jin-play-box__l">
        <h3 class="jin-play-box__title vip-video--title">
          <span v-if="isLive" class="vip-video--live-state">LIVE</span>
          <span>{{ customTitle || videoTitle || title }}</span>
        </h3>
      </div>
      <div v-if="false" class="jin-play-box__r">
        <jin-popover
          ref="qrcodePopover"
          popper-class="jin-qrcode-popover"
          placement="bottom-end"
          :open-delay="300"
          trigger="hover"
        >
          <div class="jin-qrcode">
            <dl>
              <dt>
                <p>扫描右侧二维码</p>
                <p>畅享手机看直播</p>
              </dt>
              <dd>
                <img
                  v-if="liveType === 'tradingNew'"
                  src="../../../assets/img/trading_qrcode.png"
                />
                <img v-else src="../../../assets/img/tv_qrcode.png" />
              </dd>
            </dl>
          </div>
        </jin-popover>
        <div
          v-popover:qrcodePopover
          class="jin-play-box__btn jin-play-box__phone"
        >
          <icon type="phone"></icon>
        </div>
      </div>
    </div>
    <div class="tv-video__b">
      <!-- 当repeatImageUrl没值表示不是重播 -->
      <template v-if="!repeatImageUrl">
        <div v-if="liveUrl">
          <div class="tv-video__box" v-if="isMobile">
            <video
              id="J_tv_video_vip"
              width="100%"
              height="100%"
              controls="controls"
              webkit-playsinline
              playsinline
              x-webkit-airplay="allow"
              x5-playsinline
              autoplay="autoplay"
            ></video>
          </div>
          <div v-else class="tv-video__box" id="J_tv_box_vip"></div>
        </div>
        <div v-else class="tv-video__poster" style="cursor:pointer" @click="toVipPage">
          <img :src="posterUrl" />
        </div>
      </template>
      <!-- 表示重播 -->
      <div v-else class="tv-video__poster">
        <img :src="repeatImageUrl" />
        <a
          v-if="repeatImageUrl && isVipPageAndNotAVip"
          class="tv-video__vip-link"
          @click="toVipPage"
          href="javascript:;"
        ></a>
        <jin-button v-else-if="isVip" type="primary" @click="showRepeat">
          <icon type="repeat-video"></icon>
          <span>点击这里收看最近一期节目</span>
        </jin-button>
      </div>
      <div v-if="isShowNextTV && false" class="tv-video__mask">
        <div class="tv-video-tips">
          <h4 class="tv-video-tips__h">
            温馨提示：{{ nowDatas.prevue.title }}即将直播
          </h4>
          <div class="tv-video-tips__b">
            <jin-button @click="closeNextTV">关闭</jin-button>
            <jin-button type="primary" @click="showNextTV">提前进入</jin-button>
          </div>
        </div>
      </div>
    </div>
    <div class="tv-video__f">
      <div class="tv-video__l">
        <div class="tv-video-info">
          <img
            v-if="getEmceeInfo('pic')"
            class="tv-video-info__avatar"
            :src="getEmceeInfo('pic')"
            alt=""
          />
          <span v-if="getEmceeInfo('nick')" class="tv-video-info__text"
            >关注{{ getEmceeInfo('nick') }}</span
          >
          <a
            class="tv-video-info__btn is-weibo"
            target="_blank"
            :href="getEmceeInfo('weibo')"
            v-if="getEmceeInfo('weibo')"
          >
            <icon type="weibo"></icon>
          </a>
          <jin-popover ref="wechatPopover" placement="right" trigger="hover">
            <img width="200" :src="wechatUrl" alt="" />
          </jin-popover>
          <p v-popover:wechatPopover class="tv-video-info__btn is-wechat">
            <icon v-if="wechatUrl" type="wechat"></icon>
          </p>
        </div>
      </div>
      <div class="tv-video-share">
        <share-button dir="vertical"></share-button>
      </div>
    </div>
    <vip-dialog v-model="showVipDialog"></vip-dialog>
  </div>
</template>

<script>
/* eslint-disable  */

import {mapGetters, mapState} from 'vuex';
import {fetch} from '@/commons/fetch';
import {isProduction, requestUrl} from '@/commons/config';
import {device} from '@/commons';
import VipDialog from './VipDialog';
import mixins from './video.mixin'
import {requestAttendUrl} from '@/commons/config'


export default {
  name: '',
  mixins: [mixins],
  components: {
    VipDialog,
  },
  computed: {
    ...mapGetters([
      'options',
      'liveInfo',
      'liveUrl',
      'liveType',
      'isLive',
      'isMobile',
      'serverTime',
      'posterUrl',
      'emcee',
      'videoID',
      'user',
    ]),
    ...mapState(['pageType', 'isVip', 'isEliteVip']),
    poster: {
      get() {
        return this.posterUrl;
      },
      set(v) {
        this.$store.dispatch('setPosterUrl', v);
      },
    },
    title() {
      return this.$route.meta.subTitle || this.liveInfo.title;
    },
    wechatUrl() {
      return this.getEmceeInfo('wechat');
    },
    isVipPageAndNotAVip() {
      // console.log((this.options.vipVideoFree))
      return (
        this.pageType === 'vip' && !this.isVip && !this.options.vipVideoFree ||
         ( this.pageType === 'vip' && this.options.onlySvip && !this.isEliteVip)
      );
    },
    isOnlySvipAndNotSvip() {
      return this.pageType === 'vip' && this.options.onlySvip && !this.isEliteVip
    },
    isUseM3u8() {
      return this.isMobile || device.isIpad;
    },
  },
  data() {
    return {
      tv: null,
      isLoading: false,
      isShowNextTV: false,
      isCloseNextTV: false,
      nowDatas: {},
      nowData: {},
      monitorID: '',
      timeRange: 30 * 60 * 1000,
      repeatUrl: '',
      repeatImageUrl: '',
      player: null,
      waitingTimer: null,
      curUrl: '',
      showVipDialog: false,
      videoTitle: '',
      customTitle: '',
      chatReadyState: false
    };
  },
  watch: {
    $route(to, from) {
      if (this.liveUrl) {
        this.$store.dispatch('setLiveUrl', false);
      }
      this.init();
    },
    customTitle() {
      document.title = this.customTitle || this.title;
    },
    liveUrl(v) {
      if (v) {
        if (this.isLive) {
          // 在vip直播页且不是vip的话不给直播
          if (this.isVipPageAndNotAVip) {
            return false;
          }
          this.repeatUrl = '';
          this.repeatImageUrl = '';
          this.$nextTick(() => {
            this.loadVideo(v);
          });
        // 有url且不是直播的话，说明是重播
        } else {
          this.repeatUrl = v;
          this.setRepeatImageUrl(this.options[this.liveType].repeatImage);
        }
      } else {
        // 监听liveUrl如果为空的话，只有是下发了showImage才会触发
        this.repeatUrl = '';
        this.repeatImageUrl = '';
        this.disposePlayer();
        this.clearWaitingTimer();
      }
    },
    monitorID(v, oldVal) {
      if (v) {
        // this.$socket.connection.then((socket) => {
        //   socket.emit('s', v);
        // });
      }
    },
    serverTime(v) {
      this.showNextTVTips(v);
    },
    user(v) {
      if (this.pageType === 'vip') {
        this.init();
      }
      if(this.isVipPageAndNotAVip) {
        this.showVipDialog = true
      }
      if (this.chatReadyState) {
        this.$store.dispatch('setChatReadyState', true);
      }
    },
    chatReadyState() {
      if (this.user.id || this.user.fail !== undefined) {
        this.$store.dispatch('setChatReadyState', true);
      }
    }
  },
  created() {
    // if (this.pageType !== 'vip') {
      this.$store.dispatch('setLiveUrl', false);
      this.init();
    // }
    // this.$socket.connection.then((socket) => {
    //   let eventName = 'runJs';
    //   if (location.href.indexOf('/testing/') !== -1) {
    //     eventName = 'runJsTest';
    //   }
    //   socket.on(eventName, this.onSocketData);
    // });
  },
  methods: {
    setCustomTitle(info) {
      console.log('setCustomTitle', info);
      if (info && (info.memo_title || info.title)) {
        this.customTitle = info.memo_title || info.title;
      }
    },
    setVideoTitle(datas) {
      let allDataTypes = ['prevue', 'live'];
      allDataTypes.map((el) => {
        if (datas[el] && datas[el].title) {
          this.videoTitle = datas[el].title;
        }
      });
    },
    init() {
      this.$nextTick(() => {
        this.customTitle = '';
        let routerType = this.$route.meta.type;
        this.getLiveShow(routerType).then((datas) => {
          let allDataTypes = ['live', 'prevue', 'repeat'];
          let nowData = null;
          for (let i = 0, l = allDataTypes.length; i < l; i++) {
            nowData = datas[allDataTypes[i]];
            if (Object.keys(nowData).length) {
              break;
            }
          }
          this.setVideoTitle(datas);

          let url = nowData.url;
          let type = nowData.type;
          let isLive = !!datas.live.url;
          let poster = '';
          let offline = datas.offline;
          let repeat = datas.repeat;
          let prevue = datas.prevue;
          let emcee = nowData.emcee;
          // 当有直播时，去直播的id
          let videoID = nowData.id;
          let tradingVideoID = videoID;
          // 获取统计id
          this.monitorID = nowData.monitor_id;
          if (isLive) {
            if (this.isUseM3u8) {
              url = nowData.url;
            } else {
              url = nowData.url_flv;
            }

            this.setCustomTitle(datas.live);
            this.poster = this.isVipPageAndNotAVip
              ? this.options.vip.notVipImg || this.options.vip.notVipImage
              : this.options.vip.previewImg
          } else {
            // 获取直播结束的时间，如果和当前时间相差30分钟，则显示回放图片
            if (
              this.compareTheTime(
                this.serverTime || new Date().getTime(),
                offline.live_end_time
              ) &&
              !offline.repeat_url
            ) {
              type = offline.type || routerType;
              url = '';
              emcee = offline.emcee;
              poster = this.options[type].overImg;
              tradingVideoID = offline.id;
              this.setCustomTitle(offline);
            } else {
              // 无直播时优先取预告的id
              if (prevue.id) {
                tradingVideoID = prevue.id;
              } else {
                tradingVideoID = repeat.id;
              }

              // 如果不是直播，且预告和当前时间是在30分钟外，也就是重播
              if (!this.compareTheTime(prevue.date)) {
                type = repeat.type || routerType;
                emcee = repeat.emcee;
                url = repeat.repeat_url;
                videoID = repeat.id;
                this.repeatUrl = url;
                this.setRepeatImageUrl((this.options[type] || {}).repeatImage);
                this.setCustomTitle(repeat);
              } else {
                emcee = prevue.emcee;
                url = '';
                poster = prevue.thumb
              }
            }
          }
          this.$store.dispatch('setLiveState', isLive);
          this.$store.dispatch('setLiveType', type);
          this.$store.dispatch('setEmcee', emcee);
          this.$store.dispatch('setVideoID', videoID);
          this.$store.dispatch('setTradingVideoID', tradingVideoID);
          this.chatReadyState = true;
          // this.$store.dispatch('setChatReadyState', true);
          this.$store.dispatch('setPrevueTime', datas.prevue.date);

          this.resizeSide()

          if (!url) {
            this.poster = poster || this.liveInfo.previewImg;
            return false;
          }
          if(this.isVip || this.options.vipVideoFree) {
            this.$store.dispatch('setLiveUrl', url);
          }
        })
      });
    },
    // 对比预告时间和当前时间，如果是在20分钟内返回true
    compareTheTime(endTime, startTime) {
      startTime = startTime || this.serverTime;
      startTime = this.timeTrans(startTime);
      endTime = this.timeTrans(endTime);
      const nowTime = startTime || new Date().getTime();
      const diffTime = endTime - nowTime;
      // 如果预告时间和当前时间差30分钟内
      if (diffTime > 0 && diffTime <= this.timeRange) {
        return true;
      }
      return false;
    },
    timeTrans(time) {
      if (typeof time === 'number') {
        time = time.toString().length < 13 ? time * 1000 : time;
      } else if (typeof time === 'string') {
        time = time.replace(/-/g, '/');
      }
      return new Date(time).getTime();
    },
    loadVideo(url) {
      if (this.isUseM3u8) {
        url = url.replace('.flv', '.m3u8');
      } else {
        url = url.replace('.m3u8', '.flv');
      }
      if (url.indexOf('https://') === -1) {
        url = url.replace('http:', 'https:');
      }
      this.curUrl = url;

      this.playVideo();
      this.statistics();
      this.closeNextTV();
    },
    disposePlayer() {
      if (this.player) {
        this.player.dispose();
        this.player = null;
      }
    },
    playVideo() {
      let tv = null;
      if (this.isMobile) {
        tv = document.querySelector('#J_tv_video_vip');
        tv.src = this.curUrl;

        tv.addEventListener('play', () => {
          this.report()
        })

        return false;
      }
      this.disposePlayer();
      const options = {
        mediaType: 'video',
        forceLive: this.isLive,
        sources: [this.curUrl],
        fluid: true,
        poster: this.posterUrl,
        controls: true,
        autoplay: true,
        playsinline: true,
        controlBar: {
          remainingTimeDisplay: true,
        },
      };
      if (!this.isLive) {
        options.playbackRates = [1, 1.5, 1.75, 2];
      }
      if (device.isIE) {
        options.techOrder = Jin10Player.techOrder.FLASH;
      }
      this.player = Jin10Player('#J_tv_box_vip', options, () => {
        // 如果需要把播放器的界面隐藏或者移走，请在此事件内操作
        this.clearWaitingTimer();
      });
      this.playerEvents();
    },
    playerEvents() {
      window.player = this.player;
      this.player.on('play', () => {
        console.log('play');
        this.clearWaitingTimer();

        this.report()
      });
      this.player.on('pause', () => {
        console.log('pause');
      });
      this.player.on('ended', () => {
        console.log('ended');
        this.errorReplay();
      });
      this.player.on('waiting', () => {
        console.log('waiting');
        this.errorReplay(15000);
      });
      this.player.on('ready', () => {
        // this.clearWaitingTimer()
        console.log('ready');
      });
    },
    clearWaitingTimer() {
      this.waitingTimer && clearInterval(this.waitingTimer);
    },
    errorReplay(t) {
      if (!this.isLive) {
        return false;
      }
      this.clearWaitingTimer();
      this.waitingTimer = setInterval(() => {
        this.$tips({
          message: '网络出现波动，正在尝试重新加载',
          type: 'error',
        });
        // 如果有网络的情况下才执行replay方法
        const img = new Image();
        img.src = '//fm.jin10.com/assets/imgs/network-test.png';
        img.onload = () => {
          this.playVideo();
        };
      }, t || 15000);
    },
    getLiveShow(type) {
      let params = type ? {type} : '';
      if(!isProduction) {
        params = params ? { ...params, test:'/testing/'  } : {  test:'/testing/'  }
      }

      this.isLoading = true;
      return new Promise((resolve, reject) => {
        const handleShowVipDialog = () => {
          if (this.isVipPageAndNotAVip) {
            this.showVipDialog = true;
          }
        }
        //直接打开vip直播链接时
        if(!('id' in this.user)) {
          this.$watch('user', (user) => {
            handleShowVipDialog()
        })
        //从导航栏点击进入vip频道
        } else {
          handleShowVipDialog()
        }
        fetch({
          type: 'GET',
          url: requestAttendUrl.now,
          params,
          headers: requestAttendUrl.headers,
          callback: () => {
            this.isLoading = false;
          },
          success: (res) => {
            this.nowDatas = res;
            resolve(res);
          },
          error: () => {
            this.isLoading = false;
            reject();
          },
        });
        // fetch({
        //   type: 'jsonp',
        //   url: requestUrl.now,
        //   params,
        //   callback: () => {
        //     this.isLoading = false;
        //   },
        //   success: (res) => {
        //     // console.log(res);
        //     this.nowDatas = res;
        //     resolve(res);
        //   },
        //   error: () => {
        //     this.isLoading = false;
        //     reject();
        //   },
        // });
      });
    },
    onSocketData(code) {
      let ele = document.createElement('script');
      ele.innerHTML = code;
      document.body.appendChild(ele);
    },
    // 显示重播视频
    showRepeat() {
      if (!this.repeatUrl) {
        this.$tips({message: '暂时无回放视频'});
        return false;
      }
      this.repeatImageUrl = '';
      this.$nextTick(() => {
        this.loadVideo(this.repeatUrl);
        this.repeatUrl = '';
      });
    },
    showNextTV() {
      let data = this.nowDatas.prevue;
      let type = data.type;
      let emcee =
        (type === 'tv' || type === 'fangtan') && !data.emcee
          ? 'Becca'
          : data.emcee;
      this.closeNextTV();
      this.poster = this.options[type].previewImg;
      this.$store.dispatch('setLiveUrl', '');
      this.$store.dispatch('setLiveType', type);
      this.$store.dispatch('setLiveState', false);
      // 设置主持人为预告里的主持人
      this.$store.dispatch('setEmcee', emcee);
    },
    closeNextTV() {
      if (!this.isShowNextTV) {
        return false;
      }
      this.isShowNextTV = false;
      this.isCloseNextTV = true;
    },
    showNextTVTips(serverTime) {
      if (this.posterUrl) {
        this.closeNextTV();
      }
      if (this.isCloseNextTV || this.isShowNextTV || this.posterUrl) {
        return false;
      }
      if (this.compareTheTime((this.nowDatas.prevue || {}).date, serverTime)) {
        this.isShowNextTV = true;
      }
    },
    getEmceeInfo(key, obj) {
      let url = '';
      let emcee = this.emcee;
      let liveInfo = obj || this.liveInfo;
      let data = (emcee ? liveInfo[emcee] : liveInfo) || {};
      return data[key];
    },
    statistics() {
      let img = new Image();
      img.src = `https://tv-d.jin10.com/bg.png?t=${this.videoID}`;
    },
    setRepeatImageUrl(url) {
      if (this.isVipPageAndNotAVip) {
        this.repeatImageUrl = this.isOnlySvipAndNotSvip
        ? this.options.vip.onlySvipImage
        : this.options.vip.notVipImg || this.options.vip.notVipImage;
        return false;
      }
      this.repeatImageUrl = url;
    },
    toVipPage() {
      const url = this.liveRoleType === LIVE_ROLE_TYPE.svip
        ? 'https://www.jin10.com/vip_payment/index.html#/?tab=elite'
        : 'https://www.jin10.com/vip/payment/index.html'
      if (this.jsBridge.isApp) {
        this.jsBridge.dispatch('openAppWebViewWithNav', {url});
        return false;
      }
      window.open(url, '_blank');
    },
    resizeSide() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$bus.$emit('RESIZE_SIDE')
        }, 400)
      })
    }
  },
};
</script>

<style lang="scss" scoped>
$vipVideo: 'vip-video';
.#{$vipVideo} {
  &--title {
    font-size: 21px;
    //font-family:PingFangSC-Semibold,PingFang SC;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 30px;
    //letter-spacing: 1px;
    //height: 30px;
    & > span {
      vertical-align: middle;
      display: inline-block;
      margin-top: auto;
      margin-bottom: auto;
      //line-height: 23px;
    }
  }
  &--header {
    padding-bottom: 12px;
  }
  &--live-state {
    background: rgba(240, 80, 70, 1);
    border-radius: 14px;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    //line-height:16px;
    font-size: 16px;
    line-height: 24px;
    overflow: hidden;
    //height: 23px;
    //display: inline-block;
    padding: 0px 8px;

    margin-right: 9px;
  }
}
// .dark {
//   .#{$vipVideo} {
//     &--title {
//       color: #c59f6d;
//     }
//   }
// }

@media only screen and (max-width: 768px) {
  $vipVideo: 'vip-video';
  .#{$vipVideo} {
    &--header {
      padding-bottom: 0px;
    }
    &--title {
      font-size: 14px;
    }
    &--live-state {
      background: rgba(240, 80, 70, 1);
      border-radius: 8px;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      //line-height:16px;
      font-size: 12px;
      line-height: 18px;
      overflow: hidden;
      //height: 23px;
      //display: inline-block;

      margin-right: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// vipVideo.vue?1b71d378